/**
 * This component was generated from a script. DO NOT MODIFY THIS FILE or your
 * changes will be overridden the next time icon components are generated. to
 * make persistent changes, modify the icon-template.hbs file and re run the
 * "npm run generate-icons" script
 */

import { Icon, IconProps } from '../Icon.component';

export const BlockIcon: React.FC<React.PropsWithChildren<IconProps>> = (props) => (
  <Icon size={24} {...props} viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      d='M7.0525 5.71291C8.4139 4.6401 10.1322 4 12 4C16.4183 4 20 7.58172 20 12C20 13.8678 19.3599 15.5861 18.2871 16.9475L7.0525 5.71291ZM5.64763 7.13647C4.61419 8.48424 4 10.1704 4 12C4 16.4183 7.58172 20 12 20C13.8296 20 15.5158 19.3858 16.8635 18.3524L5.64763 7.13647ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z'
    />
  </Icon>
);
